;
define("notifications_order.tpl", function(){});

